import { IAttrValue } from "@multiweb/types/contracts";
import { ITextBuilder } from "../../../../Global/Base/Builders/ITextBuilder";
import { IDisposable } from "../../../../Global/Base/IDisposable";
import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { Column } from "../Columns/Column";
import { ICellContent } from "../Components/ICellContent";

export interface IDataGridCellTemplate extends IDisposable {
    parentColumn: Column;
    init(): void;
}
export class IDataGridCellTemplate {
    private static _properties: string[] = ["parentColumn"];
    private static _methods: string[] = ["init"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value))
            && !this._methods.some(value => typeof instance[value] !== "function")
            && instance instanceof IDisposable;
    }
}

export interface IHeaderTemplate extends IDataGridCellTemplate {
    render(column: Column, index: number): HTMLElement;
}

export interface ITemplate extends IDataGridCellTemplate {
    render(column: Column, dataSet: IAttrValue[]): ICellContent;
    updateData(dataSet: IAttrValue[], item: HTMLElement): void;
    updateDisplayedData(dataSet: ITextBuilder, item: HTMLElement): void;
}

export class ITemplate {
    private static _methods: string[] = ["render", "updateData", "updateDisplayedData"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._methods.some(value => typeof instance[value] !== "function")
            && instance instanceof IDataGridCellTemplate;
    }
}

/**
 * Šablona pro editaci sloupce, který zobrazuje informace z vazebního objektu.
 * Při změně masterObjektu potřebuje být informován o změně instance.
 */
export interface IEditItemTemplateMasterRef extends ITemplate {
    /**
    * Aktualizuje instanci objektu
    * @param obj nový objekt
    * @param item HTML element, který reprezentuje buňku sloupce
    */
   setInstance(obj: OWObject, item: HTMLElement): void;
}

export class IEditItemTemplateMasterRef {
    private static _methods: string[] = ["setInstance"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._methods.some(value => typeof instance[value] !== "function")
           && instance instanceof ITemplate; //TODO:
    }
}
